import  gql  from 'graphql-tag'

export const SHARE_GENERAL_BALANCE_FTP = gql`mutation shareGeneralBalanceByFtp($input: ShareGeneralBalanceBySFTPMutationInput!){
    shareGeneralBalanceByFtp(input: $input){
        errors{
            field
            messages
        }
    }
}`;